import React, { useState } from 'react';
import API from '../api';
import { Link } from 'react-router-dom';
import toast from 'react-hot-toast';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await API.post('/auth/forgot-password', { email });
      setSubmitted(true);
    } catch (err) {
      toast.error('Something went wrong. Please try again.');
    }
  };

  if (submitted) {
    return (
      <div style={styles.container} className="container">
        <div style={styles.card}>
          <div style={{ fontSize: '48px', marginBottom: '1rem' }}>📧</div>
          <h2 style={styles.title}>Check your email!</h2>
          <p style={styles.subtitle}>If this email is registered, we sent a password reset link to <strong>{email}</strong></p>
          <p style={{ color: '#888', fontSize: '13px', marginBottom: '1.5rem' }}>Check your spam folder if you don't see it.</p>
          <Link to="/" style={styles.backLink}>← Back to Login</Link>
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container} className="container">
      <div style={styles.card}>
        <h2 style={styles.title}>Forgot Password? 🔑</h2>
        <p style={styles.subtitle}>Enter your email and we'll send you a reset link</p>
        <form onSubmit={handleSubmit}>
          <input style={styles.input} type="email" placeholder="Your email address" value={email} onChange={(e) => setEmail(e.target.value)} required />
          <button style={styles.button} type="submit">Send Reset Link</button>
        </form>
        <p style={styles.link}><Link to="/">← Back to Login</Link></p>
      </div>
    </div>
  );
};

const styles = {
  container: { display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', background: '#f0f2f5' },
  card: { background: '#fff', padding: '2rem', borderRadius: '12px', width: '100%', maxWidth: '400px', boxShadow: '0 2px 12px rgba(0,0,0,0.1)', textAlign: 'center' },
  title: { fontSize: '22px', marginBottom: '0.5rem' },
  subtitle: { color: '#888', fontSize: '14px', marginBottom: '1.5rem' },
  input: { width: '100%', padding: '10px', marginBottom: '1rem', borderRadius: '8px', border: '1px solid #ddd', fontSize: '14px', boxSizing: 'border-box' },
  button: { width: '100%', padding: '10px', background: '#4f46e5', color: '#fff', border: 'none', borderRadius: '8px', fontSize: '16px', cursor: 'pointer' },
  link: { marginTop: '1rem', fontSize: '14px' },
  backLink: { color: '#4f46e5', textDecoration: 'none', fontSize: '14px' },
};

export default ForgotPassword;